import React, { useState } from "react";
import UserService from "../services/UserService";
import firebase from "../services/FirebaseService";
import { Redirect } from "react-router-dom";
import Showdown from "showdown";
import ArticleService from "../services/ArticleService";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import "../assets/style/new-article.css";

const Editor = () => {

	const converter = new Showdown.Converter();
	const article = new ArticleService();

	const [ input, setInput ] = useState("");
	const [ pending, setPending ] = useState(false);
	const [ error, setError ] = useState("");
	const [ success, setSuccess ] = useState("");

	const submit = async (e) => {

		e.preventDefault();

		setPending(true);
		setError("");

		try {

			const id = await article.addNewArticle(input);

			

			setSuccess(id);
		}
		catch(error) {
			setError(error.message);
			setSuccess("");
			setPending(false);
		}
	}
	
	return (
		<section id="editor">
			<h1 id="title">New Article</h1>
			{ error.length > 0 && <h3 id="error">{error}</h3> }
			{ success.length > 0 && <Redirect to={"/blog/article/" + success}/>}
			<div id="flex">
				<div className="box">
					<h2 id="subtitle">Editor</h2>
					<textarea 
						onChange={e => setInput(e.target.value)}
						value={input}
						disabled={pending}
					></textarea>
				</div>	
				<div className="box">
					<h2 id="subtitle">Preview</h2>
					<div id="preview" dangerouslySetInnerHTML={{__html: converter.makeHtml(input)}}></div>
				</div>
			</div>
			<br />
			<button 
				disabled={pending}
				onClick={e => submit(e)}
			>Post Article</button>
		</section>	
	)
};

const NewArticlePage = () => {
	
	const userService = new UserService();

	const [ privileged, setPriviledged ] = useState(0);

	firebase.auth().onAuthStateChanged(async user => {
		
		if(user) {
			const isAdmin = await userService.isUserAdmin(user.uid);

			isAdmin ? setPriviledged(1) : setPriviledged(2);
		}
		else {
			setPriviledged(2);
		}

	});

	return (
		<>
			{ privileged === 2 && <Redirect to="/" /> }
			{ privileged === 1 && 
				<>
					<Navbar />
					<Editor />
					<Footer />
				</>
			}
		</>
	)

};

export default NewArticlePage;